import React from 'react';
import {  Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const DeleteFaxModal = ({isOpen, onConfirm, onCancel}) => {
    return (
      <Modal isOpen={isOpen}>
        <ModalHeader>Delete Fax?</ModalHeader>
        <ModalBody>Do you really want to delete the fax?</ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onConfirm}>Yes</Button>
          {' '}
          <Button color="secondary" onClick={onCancel}>No</Button>
        </ModalFooter>
      </Modal>
    )
};

export default DeleteFaxModal;